<template>
    <el-card  v-loading="fullScreenLoading" style="padding:0px;">

      <div class="customer-top-nav" style="margin-top:10px;height:50px;">
  			<el-page-header @back="close()" style="float:left;">
  				<div slot="title">
  					<span class="hidden-sm-and-down">Retour</span>
  				</div>
  				<div slot="content">
  					<span >Note de crédit #{{creditNote.cr_number}}</span>
  				</div>
  			</el-page-header>

  			<div class="customer-controls" style="float:right;">
          <el-button type="primary" plain size="small" @click="openCreditNoteEditor" ><i class="el-icon-edit"></i></el-button>
          <el-button  type="primary" plain size="small" @click="handleOpenSendCreditNoteDialog()" :disabled="!$can('write','Invoices')"><i class="el-icon-message"></i></el-button>
          <el-dropdown size="small" style="margin-left:10px;" >
            <el-button type="primary" size="small">
              Actions<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="processRefundCreditNote(creditNoteId)" v-if="canBeRefunded"> Marqué comme étant crédité</el-dropdown-item>
              <el-dropdown-item @click.native="handleVoidCreditNote(creditNoteId)" v-if="canBeVoided">Annuler</el-dropdown-item>
              <el-dropdown-item @click.native="handleReOpenCreditNote(creditNoteId)" v-if="canBeReOpen">Rouvrir la note de crédit</el-dropdown-item>
              <el-dropdown-item @click.native="deleteCreditNote" v-if="canBeDeleted">Supprimer</el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>
          <el-button  style="margin-left:10px;" plain size="small" @click="downloadCreditNoteReport" ><i class="el-icon-download"></i></el-button>
  			</div>
  		</div>
      <div class="pr-10 box grow scrollable only-y" :style="getHeightStyle">
        <el-tabs type="border-card"  >
          <el-tab-pane>
            <span slot="label"><i class="el-icon-info"></i> Informations <span v-if="creditNote.invoices!=null && creditNote.invoices.length>0">({{creditNote.invoices.length}})</span></span>
            <el-row>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <span class="fs-14 secondary-text">Créé par : </span>
                  <span class="fs-14 secondary-text">{{creditNote.created_by.first_name}} {{creditNote.created_by.last_name}} le {{_moment(creditNote.created_at)}}</span>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <span class="fs-14 secondary-text">Modifié par : </span>
                  <span class="fs-14 secondary-text">{{creditNote.updated_by.first_name}} {{creditNote.updated_by.last_name}} le {{_moment(creditNote.updated_at)}}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <span class="fs-14 secondary-text">Raison : </span>
                    <span class="fs-14 secondary-text" v-if="creditNote.reason!=null">{{$t('credit_notes.reasons.' + creditNote.reason.code)}}</span>
                    <span class="fs-14 secondary-text" v-else> -- </span>

                    <div v-if="creditNote.payment!=null" class="border m-10 p-10">
                        <el-row>
                          <el-col><span class="fs-14 secondary-text">Date du paiement : {{_moment(creditNote.payment.date)}}</span></el-col>
                          <el-col><span class="fs-14 secondary-text">Montant : {{$n(creditNote.payment.amount,'currency')}}</span></el-col>
                        </el-row>

                        <el-row>
                          <el-col>
                            <span class="fs-14 secondary-text">Factures : </span>
                            <span v-for="(invoice,index) in creditNote.payment.invoices" :key="invoice.id">
                              <span v-if="index>0">, </span>
                              <PortausLink fs="fs-12" :id="invoice.id" path="/invoices/" :label="invoice.inv_number"></PortausLink>
                              <span class="fs-12 secondary-text"> ({{$n(invoice.amount, 'currency', invoice.currency.code && 'CAD')}}) </span>
                            </span>
                          </el-col>
                        </el-row>
                    </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label"><i class="mdi mdi-square-inc-cash"></i> Factures <span v-if="creditNote.invoices!=null && creditNote.invoices.length>0">({{creditNote.invoices.length}})</span></span>
            <el-table
              :data="creditNote.invoices"
              stripe
              empty-text="Cette note de crédit n'a été appliquée sur aucune facture"
              style="width: 100%">
              <el-table-column
                prop="date"
                label="No. facture">
                <template slot-scope="scope">
                  <el-link @click="openInvoice(scope.row.id)">{{scope.row.inv_number}}</el-link>
                </template>
              </el-table-column>
              <el-table-column
                label="Date">
                <template slot-scope="scope">
                  <span>{{_moment(scope.row.date)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Total de la facture">
                <template slot-scope="scope">
                  <span>{{$n(scope.row.total, 'currency',creditNote.currency.code)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Montant crédité">
                <template slot-scope="scope">
                  <span>{{$n(scope.row.amount,'currency',creditNote.currency.code)}}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

        </el-tabs>
        <el-divider/>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">Client : </span>
              <span class="fs-14 secondary-text"><el-link @click="openCustomer(creditNote.customer.id)">{{customerName(creditNote.customer)}}</el-link></span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">Statut : </span>
                <el-tag size="small" style="margin-right:5px;" v-if="creditNote.status">{{$t('credit_notes.statuses.'+creditNote.status.code)}}</el-tag>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">Date : </span>
              <span class="fs-14 secondary-text" >{{_moment(creditNote.date)}}</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">Crédité le : </span>
              <span class="fs-14 secondary-text" v-if="creditNote.paid_at !== null" >{{_moment(creditNote.paid_at)}}</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <span class="fs-14 secondary-text">Référence : </span>
                <span class="fs-14 secondary-text" >{{creditNote.reference}}</span>
          </el-col>

        </el-row>
        <el-row class="mt-20">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <span class="fs-14 secondary-text">Total : </span>
              <span class="fs-14 secondary-text">{{$n(creditNote.total, 'currency',creditNote.currency.code)}}</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <span class="fs-14 secondary-text">Crédit utilisé : </span>
              <span class="fs-14 secondary-text">{{$n(creditUsed(creditNote), 'currency',creditNote.currency.code)}}</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <span class="fs-14 secondary-text">Solde : </span>
              <span class="fs-14 secondary-text">{{$n(creditBalance(creditNote), 'currency',creditNote.currency.code)}}</span>
          </el-col>


        </el-row>
        <el-divider/>
        <el-row :gutter="20" justify="center">
          <el-col :xs="24" :sm="24" :md="124" :lg="12" :xl="12">
            <el-row>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <span class="fs-14 secondary-text">Facturé à : </span>
                  <span class="fs-14 secondary-text" v-if="creditNote.billing_contact!=null">{{getName(creditNote.billing_contact, false)}}</span>
              </el-col>

            </el-row>
            <el-row style="margin-top:20px;margin-bottom:20px;">
              <el-col>
                <AddressCard  v-if="creditNote.billing_address!=null" :address="creditNote.billing_address" :ctrlVisible="false" :headerVisible="false"></AddressCard>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-divider/>
        <el-table :data="creditNote.lines" style="width:100%;" v-if="creditNote.type=='NET'">
          <el-table-column label="Type de crédit" align="left">
            <template slot-scope="scope">
                <span class="fs-14 secondary-text" v-if="scope.row.type">{{scope.row.type.name}}</span>
                <span class="fs-14 secondary-text" v-else>S.O.</span>
            </template>
          </el-table-column>
          <el-table-column label="Prix" width="150" align="center">
            <template slot-scope="scope">
                <span class="fs-14 secondary-text" >{{$n(scope.row.price,'currency',creditNote.currency.code)}}<span><br> <span class="fs-12 secondary-text">{{usedTaxesNames(scope.row)}}</span></span></span>
            </template>
          </el-table-column>

          <el-table-column label="Total" width="150" align="right">
            <template slot-scope="scope">
                  <span class="fs-14 secondary-text" >{{$n(scope.row.sub_total,'currency',creditNote.currency.code)}}<br> </span>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="creditNote.lines" style="width:100%;" v-if="creditNote.type=='PRODUCTS'">
          <el-table-column label="Description">
            <template slot-scope="scope">
                  <div v-if="scope.row.product.type==1">
                    <span>
                      <span>{{scope.row.product.name}}</span>
                      <span v-if="scope.row.product.provider!=null">, <el-link @click="openCustomer(scope.row.product.provider.id)">{{customerName(scope.row.product.provider)}}</el-link></span>
                    </span><br>
                    <span v-if="scope.row.item"><span class="fs-14 secondary-text">{{$t('invoices.lines.reference_code')}} {{scope.row.item.reference}}</span><br></span>
                    <span class="fs-14 secondary-text">{{scope.row.product.sku}}<br></span>
                    <UnitFormatVolumeLabel :unit="scope.row.product.unit" :uvc="scope.row.product.uvc" :format="scope.row.product.format" :volume="scope.row.product.volume"></UnitFormatVolumeLabel>
                    <span class="fs-14 secondary-text" v-if="scope.row.description!=''"><br>{{scope.row.description}}</span>
                  </div>
                  <div v-else>
                      <span class="fs-14 ">{{scope.row.product.name}}</span><br>
                      <span class="fs-14 secondary-text">{{scope.row.product.sku}}</span>
                      <span class="fs-14 secondary-text" v-if="scope.row.description!=''"><br>{{scope.row.description}}</span>
                  </div>
            </template>
          </el-table-column>
          <el-table-column label="Type de crédit" align="center">
            <template slot-scope="scope">
                <span class="fs-14 secondary-text" v-if="scope.row.type">{{scope.row.type.name}}<br> </span>
            </template>
          </el-table-column>
          <el-table-column label="Prix" width="150" align="center">
            <template slot-scope="scope">
                <span class="fs-14 secondary-text" >{{$n(scope.row.price,'currency',creditNote.currency.code)}}<span><br> <span class="fs-12 secondary-text">{{usedTaxesNames(scope.row)}}</span></span></span>
            </template>
          </el-table-column>
          <el-table-column prop="qty_ordered" label="Quantité" width="100" align="center">
            <template slot-scope="scope">
                  <span class="fs-14 secondary-text" >{{scope.row.qty}}<br> </span>
            </template>
          </el-table-column>
          <el-table-column label="Total" width="150" align="right">
            <template slot-scope="scope">
                  <span class="fs-14 secondary-text" >{{$n(scope.row.sub_total,'currency',creditNote.currency.code)}}<br> </span>
            </template>
          </el-table-column>
        </el-table>
        <el-row v-if="creditNote.lines.length>0">
          <table style="width:100%;margin-top:20px;">
              <tr>
                <td class="fs-14 secondary-text font-weight-800" style="text-align:right;">Sous-total : </td>
                <td class="fs-14 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(creditNote.sub_total,'currency',creditNote.currency.code)}}</td>
              </tr>
               <tr v-for="(tax, index) in creditNote.taxes" :key="index">
                <td class="fs-14 secondary-text" style="text-align:right;">{{tax.name}} ({{tax.number}}) : </td>
                <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(tax.total,'currency',creditNote.currency.code)}}</td>
              </tr>
              <tr>
                <td class="fs-14 secondary-text font-weight-800" style="text-align:right;">Total : </td>
                <td class="fs-14 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(creditNote.total,'currency',creditNote.currency.code)}}</td>
              </tr>
          </table>
        </el-row>
        <el-divider/>
        <el-row>
          <h5>   Notes</h5>
          <el-col :xs="16" :sm="16" :md="18" :lg="18" :xl="18">
              <span class="fs-14 secondary-text" v-html="creditNote.notes"></span>
          </el-col>
        </el-row>
      </div>
      <sendCreditNoteDialog  :visible="sendDialogVisible" :customerId="customerId" type="CREDIT_NOTE" :object="creditNote" @close="closeSendCreditNotDialog" @sent="creditNoteSent"></sendCreditNoteDialog>
      <CreditNoteEditor :visible="creditNoteEditorVisible" :creditNoteToEdit="creditNoteToEdit" @close="closeCreditNoteEditor" @updated="creditNoteUpdated"></CreditNoteEditor>
    </el-card>
</template>
<script>

import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import creditNoteApi from '@/services/API/creditNote'
import CreditNoteEditor from '@/components/creditNote/credit-note-editor'
import AddressCard from '@/components/address/Address-Card'
import ContactUtils from '@/utils/contact-utils.js'
import salesUtils from '@/utils/sales-utils.js'
import creditNoteUtils from '@/utils/credit-note-utils.js'
import PortausLink from '@/components/portaus-link'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
import sendCreditNoteDialog from '@/components/send-notice-dialog.vue'

export default {
  name : 'CreditNote',
  props : {
    selectedCreditNoteId : Number
  },
  data() {
    return {
      creditNote : {
        date : null,
        notes : null,
        cr_number:null,
        customer : {},
        lines : [],
        currency : {},
        created_by : {},
        updated_by : {},
        sub_total : null,
        total : null,
        status : {},
        created_at : null,
        updated_at : null,
      },
      creditNoteToEdit : null,
      window : {
        width:0,
        height : 0,
      },
      fullScreenLoading : true,
      creditNoteEditorVisible : false,
      sendDialogVisible: false,
    };
  },components : {
    sendCreditNoteDialog,
    CreditNoteEditor,
    AddressCard,
    PortausLink,
    UnitFormatVolumeLabel
  },
  watch : {
    selectedCreditNoteId: {
      immediate: true,
      handler(newVal, oldVal) {
        if(newVal){
          this.loadCreditNote(newVal);
        }
      },
    },
  },
  methods : {
    handleOpenSendCreditNoteDialog(){
      this.sendDialogVisible = true;
    },
    closeSendCreditNotDialog(){
      this.sendDialogVisible = false;
    },
    creditNoteSent(){
      console.log('SENT');
    },
    handleReOpenCreditNote(creditNoteId){
      return this.reOpenCreditNote(creditNoteId)
      .then((creditNote)=>{
        this.$message.success('La note de crédit a été réouverte');
        this.invalidateList;
        Object.assign(this.creditNote.status, creditNote.status);
      })
    },
    handleVoidCreditNote(crediteNoteId){
      return this.voidCreditNote(crediteNoteId)
        .then((creditNote)=>{
          this.$message.success('La note de crédit a été annulée!');
          this.invalidateList;
          Object.assign(this.creditNote.status, creditNote.status);
        })
        .catch(err=>{
          if(err.response.status=="409"){
            // console.log("conflict")
            this.$message({
              message : "Impossible d'annuler cette note de crédit car, elle est relié à un paiement en trop. Veuillez annuler le paiement afin de permettre l'annulation de cette note de crédit.",
              duration: 5000,
              type : 'error'
            })
          }else{
            this.$message.error("Oops... Une erreur est survenue!")
          }

        })
    },
    processRefundCreditNote(creditNoteId){
      this.refundCreditNote({creditNoteId})
        .then(creditNote=>{
          this.$message.success('La note de crédit a été créditée!');
          this.invalidateList;
          Object.assign(this.creditNote.status, creditNote.status);
        })
    },
    getName(contact){
      return ContactUtils.getName(contact, false);
    },
    downloadCreditNoteReport(){
      creditNoteApi.downloadInvoiceReport(this.creditNote.id, this.creditNote.cr_number)
    },
    deleteCreditNote(){
      this.$confirm('Voulez-vous vraiment supprimer ce crédit? Cette action sera irréversible. Voulez-vous continuer?','Attention',{
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non',
        type: 'warning'
      }).then(()=>{
        creditNoteApi.delete(this.creditNoteId)
          .then(()=>{
            this.invalidateList();
            this.close();
          }).catch(err=>{
            if(err.response.status==403){
              this.$message.error(this.$i18n.t('credit_notes.errors.'+err.response.data.jse_info.errorCode));
            }else{
              this.$message.error(this.$i18n.t('credit_notes.errors.SYSTEM'));
            }

          })
      })

    },
    usedTaxesNames(line){
      if (_.size(line.taxes) > 0)  {
        return salesUtils.getUsedTaxesNames(line.taxes);
      }
      return '';
      
    },
    creditNoteUpdated(creditNoteUpdated){
      this.fullScreenLoading = true;
      Object.assign(this.creditNote, creditNoteUpdated);
      this.fullScreenLoading = false;

    },
    openCreditNoteEditor(){
      this.creditNoteToEdit = _.cloneDeep(this.creditNote);
      this.creditNoteEditorVisible=true;
    },
    closeCreditNoteEditor(){
      this.creditNoteEditorVisible=false;
    },
    close(){
      if(this.selectedCreditNoteId!=null){
        this.$emit('close');
        this.$router.go(-1);
      }else{
        if(window.history.length>2){
          this.$router.go(-1);
        }else{
          var index='/credit-notes'
          this.$router.push(index);
        }
      }
		},
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

		},
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
			this.$router.push(index);
    },
    openInvoice(invoiceId){
      var index='/invoices/'+invoiceId;
			this.$router.push(index);
    },
    loadCreditNote(id){
      this.fullScreenLoading=true;
      this.fetchCreditStatuses();
      creditNoteApi.getCreditNotes(id)
        .then(creditNote=>{
          this.creditNote = creditNote;
          this.fullScreenLoading=false;
        }).catch(err=>{
          console.log("err : ", err);
          this.fullScreenLoading=false;
        })

    },
    ...mapActions('creditNotes',['invalidateList','refundCreditNote','voidCreditNote','reOpenCreditNote']),
    ...mapActions('statuses',['fetchCreditStatuses'])
  },
  computed : {
    customerId(){
      return _.get(this.creditNote,'customer.id');
    },
    canBeVoided(){
      return creditNoteUtils.canBeVoided(this.creditNote.status);
    },
    canBeDeleted(){
      return creditNoteUtils.canBeDeleted(this.creditNote.status);
    },
    canBeReOpen(){
      return creditNoteUtils.canBeReOpen(this.creditNote.status);
    },
    canBeRefunded(){
      return creditNoteUtils.canBeRefunded(this.creditNote.status);
    },
    getHeightStyle(){
      if(this.selectedCreditNoteId!=null){
        return "height :"+(this.window.height-300) + "px"
      }
			return "height :"+(this.window.height-220) + "px"
		},

		creditNoteId(){
      return _.get(this.creditNote, 'id');
		},
    ...mapGetters('customers',['customerName']),
    ...mapGetters('creditNotes',['creditUsed', 'creditBalance'])
  },
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();

  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted(){
    if(this.selectedCreditNoteId==null){
      this.loadCreditNote(this.$route.params.id);
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';


</style>
